import { title } from 'assets/jss/material-kit-react.js';

const aboutStyle = {
  section: {
    padding: '50px 0',
    textAlign: 'center',
  },
  title: {
    ...title,
    textTransform: 'uppercase',
    marginBottom: '1rem',
    marginTop: '30px',
    minHeight: '32px',
    textDecoration: 'none',
  },
  description: {
    color: '#999',
  },
};

export default aboutStyle;
